import React from "react";
import ErrorCard from "../../components/molecules/errorCard/errorCard";
import {useTranslation} from "react-i18next";
import {RoutePaths} from "../../shared/routePaths";
import ButtonIcon from "../../components/atoms/button/buttonIcon";
import {IconSource} from "../../shared/enums/iconSource";
import {useHistory} from "react-router";

const GenericError: React.FC = () => {
  const {t} = useTranslation(["translation"]);
  const history = useHistory();

  const onButtonClick = () => {
    history.push(RoutePaths.Home);
  };

  return (
    <ErrorCard
      title="500"
      error={t("translation:defaultErrorMessage")}
      resolution={t("translation:defaultErrorResolution")}
      children={
        <ButtonIcon
          type="primary"
          icon={IconSource.home}
          onClick={onButtonClick}
        >
          {t("translation:returnHome")}
        </ButtonIcon>
      }
    />
  );
};

export default GenericError;
